module.exports = __webpack_public_path__ + "static/img/icon-setting2.b287e5f6.svg";